<template>
  <div class="bg-container page login-page">
    <div class="dong_box">
      <div class="dong_i"></div>
    </div>
    <div class="bg-wrapper">
      <div class="login">
        <div class="language">
          <LanguageSwitcher mode="chip" />
        </div>
        <div class="wrapper">
          <div class="logo-box">
            <img src="/img/brand/logo.png" alt="" />
          </div>
          <div class="loginForm">
            <van-field
              v-model="username"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('登录.请输入用户名')"
            />
            <van-field
              v-model="password"
              :type="passwordType"
              input-align="center"
              class="input"
              :placeholder="$t('登录.请输入密码')"
            >
              <template slot="right-icon">
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>
            <van-button
              class="login-btn"
              type="primary"
              size="normal"
              :loading="loading"
              :disabled="loading"
              @click="doLogin"
            >
              {{ $t('登录.登录') }}
            </van-button>
            <div class="footer-link" @click="toRegister">
              {{ $t('登录.没有账号马上注册') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageSwitcher from '@/common/LanguageSwitcher'

export default {
  name: 'LoginPage',
  components: { LanguageSwitcher },
  data() {
    return {
      username: '',
      password: '',
      passwordType: 'password',
      loading: false,
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      this.$router.go(-1)
    }
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    toRegister() {
      this.$router.push({ path: '/Register' })
    },
    doLogin() {
      const username = this.username.trim()
      const password = this.password.trim()
      if (!username) {
        this.$toast(this.$t('登录.请输入用户名'))
        return
      }
      if (!password) {
        this.$toast(this.$t('登录.请输入密码'))
        return
      }
      this.loading = true
      this.$http({
        url: 'member_login',
        method: 'get',
        data: { username, password },
      })
        .then((res) => {
          if (res.code === 200) {
            this.$toast.success(res.msg)
            localStorage.setItem('token', res.data.token)
            this.$router.push({ path: '/Mine' })
            return
          }
          this.$toast(res.msg)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

@keyframes login-bg-shift {
  0%, 100% { background-position-x: 0; }
  50% { background-position-x: 100%; }
}

.login-page {
  min-height: 100%;
  background: #1f1c1f;
}

.dong_box {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;

  .dong_i {
    height: 100%;
    width: 100%;
    animation: login-bg-shift 20s linear infinite;
    background: url(/img/login/bg.jpg) no-repeat 0 0;
    background-size: auto 100%;
  }
}

.bg-container .bg-wrapper {
  z-index: 1;
  background: rgba(0, 0, 0, 0.55);
  background-size: 100% 100%;
}

.login {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.language {
  position: absolute;
  top: 24px;
  right: 32px;
  z-index: 3;
}

.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 80px 0 60px;
  box-sizing: border-box;
}

.logo-box {
  text-align: center;
  margin-bottom: 20px;

  img {
    width: 300px;
    max-width: 72%;
    height: auto;
    object-fit: contain;
  }
}

.loginForm {
  padding: 10px 56px 0;

  .input {
    position: relative;
    width: 100% !important;
    height: 88px;
    min-height: 88px;
    box-sizing: border-box;
    padding: 0 72px 0 28px !important;
    margin-top: 36px;
    border-radius: 12px;
    font-size: 28px;
    color: #e6b98a;
    background: linear-gradient(120deg, #212121, #313131);
    border: 2px solid #766350;
    overflow: hidden;
  }

  .login-btn {
    margin-top: 72px;
    width: 100%;
    height: 84px;
    border: none;
    border-radius: 50px;
    color: #68302c;
    background: linear-gradient(#fde3ca, #e7b486);
    font-size: 30px;
    font-weight: bolder;

    &:disabled {
      opacity: 0.6;
    }
  }
}

.footer-link {
  margin-top: 32px;
  text-align: center;
  color: #bfa77c;
  font-size: 26px;
  line-height: 1.4;
}

::v-deep .loginForm .van-cell::after {
  display: none;
}

::v-deep .loginForm .van-field__value,
::v-deep .loginForm .van-field__body {
  height: 100%;
  width: 100%;
}

::v-deep .loginForm .van-field__body {
  display: flex;
  align-items: center;
}

::v-deep .loginForm .van-field__control {
  display: block;
  width: 100%;
  height: 88px;
  line-height: 88px;
  padding: 0;
  margin: 0;
  font-size: 28px;
  color: #e6b98a;
  text-align: center;
  caret-color: #e6b98a;
}

::v-deep .loginForm .van-field__right-icon,
::v-deep .loginForm .van-field__clear {
  position: absolute;
  top: 50%;
  right: 18px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  transform: translateY(-50%);
  line-height: 1;
  font-size: 36px;
  color: #e6b98a;
}

::v-deep .loginForm .van-field__right-icon .van-icon {
  font-size: 36px;
  color: #e6b98a;
  line-height: 1;
}
</style>